import React from "react";
import { SITE_CONTENT } from "../content";

const WhyUsSection = () => {
  const { whyUs } = SITE_CONTENT.sections;

  return (
    <section
      id="why"
      style={{
        background: "var(--rest-light)",
        padding: "88px 5vw",
      }}
    >
      {/* Section heading */}
      <div style={{ textAlign: "center", marginBottom: "52px" }}>
        <span
          style={{
            display: "block",
            fontFamily: "Raleway, sans-serif",
            fontSize: "10px",
            fontWeight: 700,
            letterSpacing: "4px",
            textTransform: "uppercase",
            color: "var(--rest-red)",
            marginBottom: "10px",
          }}
        >
          {whyUs.eyebrow}
        </span>
        <h2
          style={{
            fontFamily: "Raleway, sans-serif",
            fontSize: "clamp(2rem, 5vw, 3rem)",
            fontWeight: 800,
            color: "var(--rest-dark)",
            textTransform: "uppercase",
            letterSpacing: "1px",
            lineHeight: 1.05,
          }}
        >
          {whyUs.title}
        </h2>
      </div>

      {/* Cards grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: "16px",
          maxWidth: "1100px",
          margin: "0 auto",
        }}
      >
        {whyUs.cards.map((card, idx) => (
          <WhyCard key={idx} card={card} />
        ))}
      </div>
    </section>
  );
};

const WhyCard = ({ card }) => {
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: "var(--rest-white)",
        borderRadius: "4px",
        padding: "28px 24px",
        borderTop: "4px solid var(--rest-red)",
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        boxShadow: hovered
          ? "0 10px 28px rgba(0,0,0,0.1)"
          : "0 2px 8px rgba(0,0,0,0.04)",
        transition: "transform 0.3s, box-shadow 0.3s",
      }}
    >
      <span
        style={{
          fontSize: "32px",
          display: "block",
          lineHeight: 1,
          marginBottom: "14px",
          color: card.icon === "halal" ? "var(--rest-red)" : "inherit",
        }}
      >
        {card.icon === "halal" ? (
          <svg viewBox="0 0 100 100" width="32" height="32" fill="currentColor">
            <circle
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="currentColor"
              strokeWidth="5"
            />
            <circle
              cx="50"
              cy="50"
              r="38"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            />
            <text
              x="50"
              y="55"
              fontSize="26"
              fontWeight="bold"
              textAnchor="middle"
              fill="currentColor"
            >
              حلال
            </text>
            <text
              x="50"
              y="75"
              fontSize="12"
              fontWeight="bold"
              textAnchor="middle"
              fill="currentColor"
            >
              HALAL
            </text>
          </svg>
        ) : (
          card.icon
        )}
      </span>
      <div
        style={{
          fontFamily: "Raleway, sans-serif",
          fontSize: "13px",
          fontWeight: 800,
          color: "var(--rest-dark)",
          textTransform: "uppercase",
          letterSpacing: "1px",
          marginBottom: "8px",
        }}
      >
        {card.title}
      </div>
      <p
        style={{
          fontSize: "13px",
          color: "var(--rest-gray)",
          lineHeight: 1.65,
        }}
      >
        {card.desc}
      </p>
    </div>
  );
};

export default WhyUsSection;
